export { ClerkProvider, __internal__setErrorThrowerOptions } from './ClerkProvider';
export type { ClerkProviderProps } from './ClerkProvider';
